import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiFacebook, FiInstagram, FiLinkedin, FiMail,
  FiPhone, FiMapPin, FiYoutube, FiTwitter
} from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { SiVisa, SiMastercard, SiGooglepay, SiPaytm } from 'react-icons/si';
import useSiteSettings from '../../hooks/useSiteSettings';
import './Footer.css';

const SOCIAL_ICONS = {
  facebook:  { icon: <FiFacebook />,      label: 'Facebook'   },
  instagram: { icon: <FiInstagram />,     label: 'Instagram'  },
  linkedin:  { icon: <FiLinkedin />,      label: 'LinkedIn'   },
  youtube:   { icon: <FiYoutube />,       label: 'YouTube'    },
  twitter:   { icon: <FiTwitter />,       label: 'Twitter'    },
  whatsapp:  { icon: <FaWhatsapp />, label: 'WhatsApp'   },
};

const DEFAULT_CONTACT = {
  primaryAddress: 'Angel Printers, L-8, Bisanpura, Sector 58, Noida, Uttar Pradesh - 201301',
  phone: '+91 8585949411',
  email: 'info@angelprinters.com',
  hours: 'Mon – Sat: 10am – 7pm IST',
};
const DEFAULT_SOCIAL = {
  youtube:   'https://www.youtube.com/@angelprintersindia',
  instagram: 'https://www.instagram.com/angelprintersindia/',
  facebook:  'https://www.facebook.com/angelprintersindia/',
  linkedin:  'https://www.linkedin.com/company/angelprinters/',
};

const Footer = () => {
  const { data: contact } = useSiteSettings('contact');
  const { data: social  } = useSiteSettings('social');

  const c = contact || DEFAULT_CONTACT;
  const s = social  || DEFAULT_SOCIAL;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">

          {/* Brand col */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo_White.svg" alt="Angel Printers" style={{ height: 42, width: 'auto', padding: '4px 8px' }} />
            </Link>
            <p>Premium print-on-demand services for businesses and individuals. Quality printing, fast turnaround, delivered to your door.</p>

            {/* Newsletter in footer */}
            {/* <div className="footer-newsletter">
              <input type="email" placeholder="Enter your email" />
              <button className="footer-sub-btn">Subscribe</button>
            </div> */}

            <div className="footer-socials">
              {Object.entries(SOCIAL_ICONS).map(([key, { icon, label }]) => {
                const url = s[key];
                if (!url) return null;
                return (
                  <a key={key} href={url} target="_blank" rel="noopener noreferrer" aria-label={label}>
                    {icon}
                  </a>
                );
              })}
            </div>
          </div>

          {/* Products */}
          <div className="footer-col">
            <h4>Products</h4>
            <Link to="/business-cards">Business Cards</Link>
            <Link to="/stamps-and-ink">Stamps & Ink</Link>
            <Link to="/flyers">Flyers</Link>
            <Link to="/brochures">Brochures</Link>
            <Link to="/posters">Posters</Link>
            <Link to="/banners">Banners</Link>
            <Link to="/stickers">Stickers</Link>
          </div>

          {/* Company */}
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/services">How It Works</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/contact?type=quote">Bulk Order</Link>
            {/* <Link to="/blog">Blog</Link> */}
          </div>

          {/* Support */}
          <div className="footer-col">
            <h4>Support</h4>
            <Link to="/help">Help Center</Link>
            {/* <Link to="/track-order">Track Order</Link> */}
            <Link to="/shipping">Shipping &amp; Delivery</Link>
            <Link to="/returns">Returns</Link>
            <Link to="/contact">Contact Us</Link>
          </div>

          {/* Follow + Payment */}
          <div className="footer-col">
            {/* <h4>Follow Us</h4>
            <div className="footer-socials-col">
              {Object.entries(SOCIAL_ICONS).map(([key, { icon, label }]) => {
                const url = s[key];
                if (!url) return null;
                return (
                  <a key={key} href={url} target="_blank" rel="noopener noreferrer" className="footer-social-row">
                    {icon} {label}
                  </a>
                );
              })}
            </div> */}

            <h4 style={{ marginTop: 28 }}>We Accept</h4>
            <div className="footer-payments">
              <span className="payment-chip"><SiMastercard size={28} color="#eb001b" /></span>
              <span className="payment-chip"><SiVisa size={28} color="#1a1f71" /></span>
              <span className="payment-chip"><SiGooglepay size={28} color="#4285f4" /></span>
              <span className="payment-chip"><SiPaytm size={28} color="#00baf2" /></span>
              {/* <span className="payment-chip upi">UPI</span> */}
            </div>
          </div>
        </div>

        {/* WhatsApp FAB */}
        <a
          href={`https://wa.me/${(c.phone || '').replace(/\D/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-fab"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp size={24} />
        </a>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Angel Printers. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/shipping">Shipping Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;